import { Directive, HostListener, forwardRef } from '@angular/core';
import {
    DefaultValueAccessor,
    NG_VALUE_ACCESSOR
} from '@angular/forms';

const TRIM_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TrimControlDirective),
  multi: true,
};

@Directive({
  selector: '[trimControl]',
  providers: [TRIM_VALUE_ACCESSOR],
  standalone: false
})
export class TrimControlDirective extends DefaultValueAccessor {
  @HostListener('blur', ['$event.target.value'])
  trimValue(val: string) {
    super.writeValue(val.trim());
  }
}
